import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import ErrorBoundary from './components/ErrorBoundary';
import Dashboard from './pages/Dashboard';
import Events from './pages/Events';
import Calendar from './pages/Calendar';
import Conflicts from './pages/Conflicts';
import Search from './pages/Search';
import EventDetail from './pages/EventDetail';
import ClinicsList from './pages/ClinicsList';
import ClinicProfile from './pages/ClinicProfile';
import LocationProfile from './pages/LocationProfile';
import MapView from './pages/MapView';
import Cities from './pages/Cities';
import AdStats from './pages/AdStats';
import Targeting from './pages/Targeting';
import Reports from './pages/Reports';
import Login from './pages/Login';
import { useAuth } from './context/AuthContext';

function ProtectedApp() {
  const { loading, authRequired, isAuthenticated } = useAuth();

  if (loading) {
    return (
      <div
        className="min-h-screen flex items-center justify-center bg-gray-50"
        role="status"
        aria-live="polite"
      >
        <p className="text-gray-500">Loading, please wait.</p>
      </div>
    );
  }

  if (authRequired && !isAuthenticated) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <ErrorBoundary>
      <Layout>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/clinics" element={<ClinicsList />} />
          <Route path="/clinics/:name" element={<ClinicProfile />} />
          <Route path="/locations/:name" element={<LocationProfile />} />
          <Route path="/map" element={<MapView />} />
          <Route path="/cities" element={<Cities />} />
          <Route path="/events" element={<Events />} />
          <Route path="/events/:id" element={<EventDetail />} />
          <Route path="/ad-stats" element={<AdStats />} />
          <Route path="/targeting" element={<Targeting />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/calendar" element={<Calendar />} />
          <Route path="/conflicts" element={<Conflicts />} />
          <Route path="/search" element={<Search />} />
        </Routes>
      </Layout>
    </ErrorBoundary>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <ProtectedApp />
    </ErrorBoundary>
  );
}

export default App;
